/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_SAL_EVOLUTION_ITEM = {
  id: 'sales_evolution',
  screenId: 'met-sal-evolution',
  label: 'Evolución',
  description: 'Ventas en el tiempo (por día o mes).',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Comparás cómo evolucionaron las ventas a lo largo del período elegido.',
      },
      {
        title: 'Paso 1 — Elegir vista',
        bullets: [
          'Semestral — ventas por mes de los últimos 6 meses (podés ir a semestres anteriores). Incluye inflación mensual y ventas ajustadas cuando hay datos.',
          'Mensual — ventas por día dentro de un mes (últimos 30 días o meses anteriores).',
          'Diaria — ventas por hora del día (última semana).',
        ],
      },
      {
        title: 'Paso 2 — Leer el gráfico',
        paragraphs: [
          'Barras de ventas en el eje temporal de la vista elegida. En semestral también podés ver la serie de inflación y ventas ajustadas.',
        ],
      },
    ],
  },
}
